module.exports = __webpack_public_path__ + "img/mj_white_50px.58b02ab5.png";